
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33612',
  depVersions: {
  "documents-public-ui": "static-1.33612",
  "client-types": "static-1.437",
  "documents-lib": "static-1.33617",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1787",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5260",
  "hs-test-utils": "static-1.7653",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11089",
  "I18n": "static-7.1535",
  "jasmine-immutable": "static-1.2681",
  "jasmine-runner": "static-1.6123",
  "lodash": "static-1.3",
  "quartz": "static-1.6537",
  "react": "static-7.174",
  "react-dlb": "static-1.68",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16296",
  "reporting-data": "static-1.65940",
  "reporting-testing-lib": "static-1.7874",
  "reporting-visualizations": "static-1.58017",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4414",
  "webpack-env": "static-1.54",
  "atom": "static-1.4743",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2131",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90837",
  "cssUtils": "static-1.690",
  "customer-data-filters-ui": "static-1.38408",
  "customer-data-objects": "static-1.7281",
  "customer-data-property-utils": "static-1.7735",
  "data-fetching-client": "static-1.9344",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4206",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84885",
  "FormUrlGenerator": "static-2.4402",
  "foundations-components": "static-1.7235",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11397",
  "icons": "static-2.608",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6810",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3530",
  "property-translator": "static-1.5084",
  "quartz-config": "static-1.315",
  "quartz-core": "static-1.5756",
  "quick-fetch": "static-1.3608",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5058",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7829",
  "reference-resolvers-lite": "static-1.7761",
  "report-customization-components": "static-1.12150",
  "reporting-enablement": "static-1.21629",
  "reporting-reports": "static-1.65619",
  "reporting-snowflake": "static-1.54559",
  "reporting-ui-components": "static-2.63213",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4273",
  "sales-content-partitioning": "static-1.8605",
  "SalesContentIndexUI": "static-3.8701",
  "sanitize": "static-1.4146",
  "sanitize-text": "static-1.7811",
  "self-service-api": "static-1.9895",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1451",
  "signup-constants": "static-1.18116",
  "signup-ui-lego-core": "static-1.20126",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4438",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10667",
  "ui-addon-i18n": "static-1.10795",
  "ui-addon-react-router-dom": "static-1.9212",
  "ui-addon-upgrades": "static-9.17373",
  "ui-asset-management-lib": "static-1.10515",
  "ui-images": "static-2.1050",
  "UIComponents": "static-3.8036",
  "usage-tracker": "static-1.7006",
  "usage-tracker-container": "static-1.6996",
  "usage-tracker-core": "static-1.6856",
  "usage-tracker-public": "static-1.6817",
  "viral-links-lib": "static-1.6683",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3105",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2814",
  "quartz-webpack": "static-1.2761",
  "ai-components-ui-library": "static-1.8002",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4500",
  "foundations-theming": "static-1.4071",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4692",
  "foundations-theming-base": "static-1.3056",
  "HeadJS": "static-2.685",
  "framer-motion": "static-1.62",
  "hs-test-utils-bend-plugin": "static-1.2764",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4004",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7593",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3338",
  "persist-promise": "static-1.3354",
  "reporting-client-types": "static-1.2347",
  "hs-story-utils": "static-1.9100",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9138",
  "hubspotter-http": "static-1.4357",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6922",
  "crm-message-bus": "static-1.41982",
  "customer-data-filters-ui-msw-helpers": "static-1.20842",
  "customer-data-objects-ui-components": "static-1.12670",
  "customer-data-reference-ui-components": "static-1.12795",
  "customer-data-ui-utilities": "static-1.9493",
  "framework-builder-read-service-client": "static-1.3726",
  "framework-data-schema-quick-fetch": "static-1.6439",
  "framework-data-schema-resolvers": "static-1.6534",
  "inbound-db-properties-service-client": "static-1.3557",
  "multi-account-reference-resolvers": "static-1.633",
  "onboarding-tours": "static-1.16083",
  "reporting-datasets-permissions-lib": "static-1.12617",
  "ui-addon-teams": "static-1.21040",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67192",
  "customer-data-properties": "static-1.50388",
  "forms-ai-lib": "static-1.3785",
  "forms-utils-lib": "static-1.11916",
  "foundations-components-test-utils": "static-1.4718",
  "react-dnd-compat": "static-1.4295",
  "react-tinymce": "static-1.54256",
  "tinymce-config": "static-2.53382",
  "ui-gdpr-components": "static-1.10016",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3504",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.925",
  "ui-fonts": "static-1.351",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.765",
  "mobile-manifest-mixins": "static-1.458",
  "quartz-auth": "static-1.212",
  "quartz-head": "static-1.202",
  "quartz-i18n": "static-1.212",
  "quartz-test": "static-1.212",
  "batch-promise": "static-1.1197",
  "external-options-client-types": "static-1.3862",
  "react-colorpicker": "static-2.9884",
  "reporting-insights-lib": "static-1.779",
  "copilot-toolkit": "static-1.10196",
  "data-quality-ui-library": "static-1.12022",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40351",
  "reporting-plugins": "static-1.9803",
  "ui-addon-draggable-compat": "static-2.3925",
  "ui-addon-opt": "static-4.8060",
  "ui-shepherd-react": "static-3.9810",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24346",
  "hubspot-apollo-client": "static-1.4551",
  "sales-templates-service-types-lib": "static-1.3873",
  "ui-business-units-lib": "static-1.8678",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4199",
  "purchase-motions-components": "static-1.5287",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3783",
  "upgrade-management-service-types": "static-1.4190",
  "timezone-utils": "static-2.4915",
  "bender-build-tools": "static-1.2779",
  "chatspot-core": "static-1.19813",
  "bend-plugin-foundations-theming": "static-1.2554",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3501",
  "crm-pipelines-api-client-types": "static-1.3844",
  "multi-currency-client-types": "static-1.3401",
  "getting-started-shared-tasks": "static-1.17484",
  "growth-data-modal": "static-1.5000",
  "growth-onboarding-confetti": "static-1.2722",
  "growth-onboarding-next-action-utils": "static-1.1159",
  "navigation-components": "static-1.16889",
  "onboarding-tours-client": "static-1.4297",
  "onboarding-tours-utils": "static-1.149",
  "ui-shepherd-tracker": "static-1.7191",
  "ui-universal-auth": "static-1.8508",
  "user-context": "static-1.4758",
  "cms-field-types": "static-1.4473",
  "content-icons-ui": "static-1.2106",
  "integrations-lib": "static-1.14991",
  "calling-global-api": "static-1.63200",
  "calling-internal-common": "static-1.30958",
  "calling-lifecycle-internal": "static-1.64582",
  "calling-lifecycle-messages": "static-1.56876",
  "commerce-products-lib": "static-1.8448",
  "crm-links": "static-1.5914",
  "file-manager-components": "static-1.22501",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.319",
  "inbounddb-objects-service-types": "static-1.3929",
  "meetings-icalendar-utils-lib": "static-1.304",
  "object-builder-ui-client": "static-1.47531",
  "pipeline-validation-client-types": "static-1.3665",
  "property-value-citations": "static-1.1002",
  "pulse": "static-1.152",
  "smart-property-lib": "static-1.5399",
  "tiered-pricing": "static-1.620",
  "ui-addon-iframeable": "static-1.8675",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19242",
  "tinymce-themes": "static-1.55352",
  "data-token-picker": "static-1.15832",
  "hub-http-contrib": "static-1.2718",
  "interframe": "static-3.4459",
  "tinymce-data": "static-1.39467",
  "tinymce-plugins": "static-1.56496",
  "ui-addon-sales-email": "static-1.4885",
  "hubspotter-http-shared-msw-handlers": "static-1.9136",
  "magpie-lib": "static-1.5244",
  "magpie-types": "static-1.4704",
  "simple-logging-lib": "static-1.2721",
  "content-assistance-lib": "static-1.7258",
  "dashboard-lib": "static-1.80105",
  "ExportDialog": "static-6.10057",
  "hubspot-prosemirror": "static-1.17248",
  "hubspot-prosemirror-plugins": "static-1.17240",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8358",
  "campaign-roi-lib": "static-1.7893",
  "feedback-loader": "static-1.28626",
  "commerce-analytics-service-client": "static-1.3352",
  "onboarding-scopes": "static-1.6112",
  "apollo-link-hub-http": "static-2.4319",
  "hubspot-apollo-cache": "static-1.10",
  "growth-monetization-service-types": "static-1.4206",
  "nav-client-types": "static-1.2003",
  "purchase-motions-api": "static-1.5290",
  "trials-service-types": "static-1.3607",
  "chatspot-client-types": "static-1.10310",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.397",
  "getting-started-shared-tasks-store": "static-1.16602",
  "integrations-error-boundary-lib": "static-1.12406",
  "integrations-tracking-lib": "static-1.5254",
  "native-integrations-shared-strings": "static-1.7457",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10045",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30964",
  "shared-worker-versioning": "static-1.10688",
  "calling-usage-tracker": "static-1.6209",
  "calling-orchestration-shared-library": "static-1.34388",
  "customer-data-tracking": "static-1.6531",
  "products-iframe-lib": "static-1.6999",
  "products-ui-components-shared-msw-handlers": "static-1.9520",
  "location-customization-utils-lib": "static-1.8131",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3826",
  "video-components-external": "static-1.10159",
  "video-data-lib": "static-1.33817",
  "directed-graph": "static-1.605",
  "event-emitter": "static-1.596",
  "breeze-intelligence-kit": "static-1.5130",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9221",
  "fsm": "static-1.3401",
  "policy-lib": "static-1.6472",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9284",
  "navigation-messaging": "static-1.6216",
  "FileManagerLib": "static-1.38141",
  "NamespacedHubStyle": "static-2.8781",
  "FileManagerCore": "static-1.38000",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11808",
  "layout-dnd-utils": "static-1.10783",
  "react-codemirror": "static-1.10273",
  "ui-addon-emoji-picker": "static-1.9561",
  "ui-brand-identity-lib": "static-1.13330",
  "ui-addon-video-player": "static-1.8392",
  "ui-coaching-tips": "static-1.27573",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22572",
  "EmailSignatureEditor": "static-1.23685",
  "eligibility-engine-service-types": "static-1.2888",
  "universal-page-editor-lib": "static-1.2667",
  "calling-orchestration-schema": "static-1.34613",
  "sales-views-client-types": "static-1.3963",
  "crm-record-cards-service-types": "static-1.3338",
  "content-media-composition-data-lib": "static-1.10885",
  "content-media-compositions": "static-2.14892",
  "media-bridge-lib": "static-1.18357",
  "trellis-story-utils": "static-1.4194",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5426",
  "FileManagerImages": "static-1.35652",
  "video-components": "static-1.12162",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4195",
  "video-embed": "static-1.34651",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67267",
  "layout-data-lib": "static-1.9108",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6257",
  "commerce-tours-lib": "static-1.5515",
  "growth-onboarding-reliability": "static-1.4759",
  "sales-checkout-service-client": "static-1.3364",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21081",
  "sales-email-signature-service-client": "static-1.3509",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21042",
  "outpost": "static-1.3886",
  "advanced-menus-core": "static-1.14608",
  "advanced-menus-lib": "static-1.11608",
  "ui-memberships-settings-lib": "static-1.33063",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14607",
  "simple-menus-lib": "static-1.16124"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33612",
  "client-types": "/client-types/static-1.437",
  "documents-lib": "/documents-lib/static-1.33617",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1787",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5260",
  "hs-test-utils": "/hs-test-utils/static-1.7653",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11089",
  "I18n": "/I18n/static-7.1535",
  "jasmine-immutable": "/jasmine-immutable/static-1.2681",
  "jasmine-runner": "/jasmine-runner/static-1.6123",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6537",
  "react": "/react/static-7.174",
  "react-dlb": "/react-dlb/static-1.68",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16296",
  "reporting-data": "/reporting-data/static-1.65940",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7874",
  "reporting-visualizations": "/reporting-visualizations/static-1.58017",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4414",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4743",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2131",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90837",
  "cssUtils": "/cssUtils/static-1.690",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38408",
  "customer-data-objects": "/customer-data-objects/static-1.7281",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7735",
  "data-fetching-client": "/data-fetching-client/static-1.9344",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4206",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84885",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4402",
  "foundations-components": "/foundations-components/static-1.7235",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11397",
  "icons": "/icons/static-2.608",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6810",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3530",
  "property-translator": "/property-translator/static-1.5084",
  "quartz-config": "/quartz-config/static-1.315",
  "quartz-core": "/quartz-core/static-1.5756",
  "quick-fetch": "/quick-fetch/static-1.3608",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5058",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7829",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7761",
  "report-customization-components": "/report-customization-components/static-1.12150",
  "reporting-enablement": "/reporting-enablement/static-1.21629",
  "reporting-reports": "/reporting-reports/static-1.65619",
  "reporting-snowflake": "/reporting-snowflake/static-1.54559",
  "reporting-ui-components": "/reporting-ui-components/static-2.63213",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4273",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8605",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8701",
  "sanitize": "/sanitize/static-1.4146",
  "sanitize-text": "/sanitize-text/static-1.7811",
  "self-service-api": "/self-service-api/static-1.9895",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1451",
  "signup-constants": "/signup-constants/static-1.18116",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20126",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4438",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10667",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10795",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9212",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17373",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10515",
  "ui-images": "/ui-images/static-2.1050",
  "UIComponents": "/UIComponents/static-3.8036",
  "usage-tracker": "/usage-tracker/static-1.7006",
  "usage-tracker-container": "/usage-tracker-container/static-1.6996",
  "usage-tracker-core": "/usage-tracker-core/static-1.6856",
  "usage-tracker-public": "/usage-tracker-public/static-1.6817",
  "viral-links-lib": "/viral-links-lib/static-1.6683",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3105",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2814",
  "quartz-webpack": "/quartz-webpack/static-1.2761",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8002",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4500",
  "foundations-theming": "/foundations-theming/static-1.4071",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4692",
  "foundations-theming-base": "/foundations-theming-base/static-1.3056",
  "HeadJS": "/HeadJS/static-2.685",
  "framer-motion": "/framer-motion/static-1.62",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2764",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4004",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7593",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3338",
  "persist-promise": "/persist-promise/static-1.3354",
  "reporting-client-types": "/reporting-client-types/static-1.2347",
  "hs-story-utils": "/hs-story-utils/static-1.9100",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9138",
  "hubspotter-http": "/hubspotter-http/static-1.4357",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6922",
  "crm-message-bus": "/crm-message-bus/static-1.41982",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20842",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12670",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12795",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9493",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3726",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6439",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6534",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3557",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.633",
  "onboarding-tours": "/onboarding-tours/static-1.16083",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12617",
  "ui-addon-teams": "/ui-addon-teams/static-1.21040",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67192",
  "customer-data-properties": "/customer-data-properties/static-1.50388",
  "forms-ai-lib": "/forms-ai-lib/static-1.3785",
  "forms-utils-lib": "/forms-utils-lib/static-1.11916",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4718",
  "react-dnd-compat": "/react-dnd-compat/static-1.4295",
  "react-tinymce": "/react-tinymce/static-1.54256",
  "tinymce-config": "/tinymce-config/static-2.53382",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10016",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3504",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.925",
  "ui-fonts": "/ui-fonts/static-1.351",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.765",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.458",
  "quartz-auth": "/quartz-auth/static-1.212",
  "quartz-head": "/quartz-head/static-1.202",
  "quartz-i18n": "/quartz-i18n/static-1.212",
  "quartz-test": "/quartz-test/static-1.212",
  "batch-promise": "/batch-promise/static-1.1197",
  "external-options-client-types": "/external-options-client-types/static-1.3862",
  "react-colorpicker": "/react-colorpicker/static-2.9884",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.779",
  "copilot-toolkit": "/copilot-toolkit/static-1.10196",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12022",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40351",
  "reporting-plugins": "/reporting-plugins/static-1.9803",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3925",
  "ui-addon-opt": "/ui-addon-opt/static-4.8060",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9810",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24346",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4551",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3873",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8678",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4199",
  "purchase-motions-components": "/purchase-motions-components/static-1.5287",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3783",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4190",
  "timezone-utils": "/timezone-utils/static-2.4915",
  "bender-build-tools": "/bender-build-tools/static-1.2779",
  "chatspot-core": "/chatspot-core/static-1.19813",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2554",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3501",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3844",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3401",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17484",
  "growth-data-modal": "/growth-data-modal/static-1.5000",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2722",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1159",
  "navigation-components": "/navigation-components/static-1.16889",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4297",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.149",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7191",
  "ui-universal-auth": "/ui-universal-auth/static-1.8508",
  "user-context": "/user-context/static-1.4758",
  "cms-field-types": "/cms-field-types/static-1.4473",
  "content-icons-ui": "/content-icons-ui/static-1.2106",
  "integrations-lib": "/integrations-lib/static-1.14991",
  "calling-global-api": "/calling-global-api/static-1.63200",
  "calling-internal-common": "/calling-internal-common/static-1.30958",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64582",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56876",
  "commerce-products-lib": "/commerce-products-lib/static-1.8448",
  "crm-links": "/crm-links/static-1.5914",
  "file-manager-components": "/file-manager-components/static-1.22501",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.319",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3929",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.304",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47531",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3665",
  "property-value-citations": "/property-value-citations/static-1.1002",
  "pulse": "/pulse/static-1.152",
  "smart-property-lib": "/smart-property-lib/static-1.5399",
  "tiered-pricing": "/tiered-pricing/static-1.620",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8675",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19242",
  "tinymce-themes": "/tinymce-themes/static-1.55352",
  "data-token-picker": "/data-token-picker/static-1.15832",
  "hub-http-contrib": "/hub-http-contrib/static-1.2718",
  "interframe": "/interframe/static-3.4459",
  "tinymce-data": "/tinymce-data/static-1.39467",
  "tinymce-plugins": "/tinymce-plugins/static-1.56496",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4885",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9136",
  "magpie-lib": "/magpie-lib/static-1.5244",
  "magpie-types": "/magpie-types/static-1.4704",
  "simple-logging-lib": "/simple-logging-lib/static-1.2721",
  "content-assistance-lib": "/content-assistance-lib/static-1.7258",
  "dashboard-lib": "/dashboard-lib/static-1.80105",
  "ExportDialog": "/ExportDialog/static-6.10057",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17248",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17240",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8358",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7893",
  "feedback-loader": "/feedback-loader/static-1.28626",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3352",
  "onboarding-scopes": "/onboarding-scopes/static-1.6112",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4319",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.10",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4206",
  "nav-client-types": "/nav-client-types/static-1.2003",
  "purchase-motions-api": "/purchase-motions-api/static-1.5290",
  "trials-service-types": "/trials-service-types/static-1.3607",
  "chatspot-client-types": "/chatspot-client-types/static-1.10310",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.397",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16602",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12406",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5254",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7457",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10045",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30964",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10688",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6209",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34388",
  "customer-data-tracking": "/customer-data-tracking/static-1.6531",
  "products-iframe-lib": "/products-iframe-lib/static-1.6999",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9520",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8131",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3826",
  "video-components-external": "/video-components-external/static-1.10159",
  "video-data-lib": "/video-data-lib/static-1.33817",
  "directed-graph": "/directed-graph/static-1.605",
  "event-emitter": "/event-emitter/static-1.596",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5130",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9221",
  "fsm": "/fsm/static-1.3401",
  "policy-lib": "/policy-lib/static-1.6472",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9284",
  "navigation-messaging": "/navigation-messaging/static-1.6216",
  "FileManagerLib": "/FileManagerLib/static-1.38141",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8781",
  "FileManagerCore": "/FileManagerCore/static-1.38000",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11808",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10783",
  "react-codemirror": "/react-codemirror/static-1.10273",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9561",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13330",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8392",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27573",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22572",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23685",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2888",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2667",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34613",
  "sales-views-client-types": "/sales-views-client-types/static-1.3963",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3338",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10885",
  "content-media-compositions": "/content-media-compositions/static-2.14892",
  "media-bridge-lib": "/media-bridge-lib/static-1.18357",
  "trellis-story-utils": "/trellis-story-utils/static-1.4194",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5426",
  "FileManagerImages": "/FileManagerImages/static-1.35652",
  "video-components": "/video-components/static-1.12162",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4195",
  "video-embed": "/video-embed/static-1.34651",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67267",
  "layout-data-lib": "/layout-data-lib/static-1.9108",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6257",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5515",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4759",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3364",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21081",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3509",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21042",
  "outpost": "/outpost/static-1.3886",
  "advanced-menus-core": "/advanced-menus-core/static-1.14608",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11608",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33063",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14607",
  "simple-menus-lib": "/simple-menus-lib/static-1.16124"
}
};
